import {Component, HostBinding, HostListener, Input} from "@angular/core";
import {FUIFormContext} from "../../../form-context/form-context";
import {FUIEditFormContext} from "../../../form-context/edit-form-context";

@Component({
    selector: "fui-radio-group",
    styleUrls: ["./radio-group.component.scss"],
    templateUrl: "./radio-group.component.html",
    providers: [{ provide: FUIFormContext, useClass: FUIEditFormContext }],
    standalone: false
})
export class FUIRadioGroupComponent {
    @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @Input() i18nParams: any = {};
    @HostBinding("class.hovered") public hovered: boolean;

    @HostListener("mouseenter")
    public mouseenter(): void {
        this.hovered = true;
    }

    @HostListener("mouseleave")
    public mouseleave(): void {
        this.hovered = false;
    }
}
